import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { api } from '../lib/api';

export function AuthGuard() {
  const [state, setState] = useState<'loading' | 'authed' | 'guest'>('loading');
  const [needsOnboarding, setNeedsOnboarding] = useState(false);
  const location = useLocation();

  useEffect(() => {
    api.get('/auth/me')
      .then((r) => {
        setState('authed');
        setNeedsOnboarding(!r.data.user.onboardingCompleted);
      })
      .catch(() => setState('guest'));
  }, []);

  if (state === 'loading') return <div className="flex h-screen items-center justify-center text-white/30 text-sm">Loading...</div>;
  if (state === 'guest') return <Navigate to="/login" replace />;
  if (needsOnboarding && !location.pathname.startsWith('/onboarding')) return <Navigate to="/onboarding" replace />;
  return <Outlet />;
}
